module.exports = require("@swa-ui/core/src/ProgressBar/ProgressBar.module.scss");